import React, { useState } from 'react';
import { FiUser, FiEdit } from 'react-icons/fi';
import UserProfileForm from '../../components/forms/UserProfileForm';
import { useAuth } from '../../hooks/useAuth';
import { useAsync } from 'react-async-hook';
import * as sched from 'sched';
import { Avatar } from 'flowbite-react';

const ProfilePage: React.FC = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const { user, token, client } = useAuth();

  const { result: userProfile } = useAsync(async () => {
    if (!user || !token || !client) return null;
    try {
      return await sched.WrappedApiClient.get_user_profile(client, token, user.userId);
    } catch {
      return null;
    }
  }, [user, token, client]);

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-mono font-semibold text-cm-text-primary">Profile</h1>
        <p className="mt-1 text-sm text-cm-text-secondary">
          Manage your user profile and preferences.
        </p>
      </div>

      <div className="rounded-xl border border-cm-border-subtle bg-cm-bg-surface p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <Avatar
              alt="User profile"
              img={userProfile?.avatar_url || undefined}
              rounded
              size="lg"
            />
            <div>
              <h2 className="text-lg font-medium text-cm-text-primary">
                {userProfile?.display_name || 'Set up your profile'}
              </h2>
              <p className="text-sm text-cm-text-muted">{userProfile?.email || ''}</p>
            </div>
          </div>
          <button
            onClick={() => setShowEditModal(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-cm-accent-orange text-cm-bg-deep font-mono text-sm font-medium hover:opacity-90 transition-opacity"
          >
            <FiEdit className="w-4 h-4" />
            Edit
          </button>
        </div>
      </div>

      <UserProfileForm
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSuccess={() => setShowEditModal(false)}
      />
    </div>
  );
};

export default ProfilePage;
